import useFlag, { FLAGS } from '@rover/shared/js/hooks/useFlag';

export type SearchByNameExperimentState = {
  isEnabled: boolean;
};

// Backend-evaluated via FrontendConfigurationView so the value is present on first paint —
// the Statsig JS SDK is unreliable for authenticated users on this page (DEV-135383).
export function useSearchByNameExperiment(): SearchByNameExperimentState {
  return { isEnabled: useFlag(FLAGS.ROLLOUT_SEARCH_BY_NAME) };
}
